module.exports = __webpack_public_path__ + "static/media/Speaker - Gunjan Dhingra.1eb6c76f.jpeg";